/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginWithEmailorUsernameAuthToken
 */
export interface LoginWithEmailorUsernameAuthToken {
    /**
     * 
     * @type {string}
     * @memberof LoginWithEmailorUsernameAuthToken
     */
    identifier: string;
    /**
     * 
     * @type {string}
     * @memberof LoginWithEmailorUsernameAuthToken
     */
    password: string;
}

/**
 * Check if a given object implements the LoginWithEmailorUsernameAuthToken interface.
 */
export function instanceOfLoginWithEmailorUsernameAuthToken(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "identifier" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function LoginWithEmailorUsernameAuthTokenFromJSON(json: any): LoginWithEmailorUsernameAuthToken {
    return LoginWithEmailorUsernameAuthTokenFromJSONTyped(json, false);
}

export function LoginWithEmailorUsernameAuthTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginWithEmailorUsernameAuthToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'identifier': json['identifier'],
        'password': json['password'],
    };
}

export function LoginWithEmailorUsernameAuthTokenToJSON(value?: LoginWithEmailorUsernameAuthToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'identifier': value.identifier,
        'password': value.password,
    };
}

